/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TextInfo, {
  KIND_TEXT,
  COLOR,
  ALIGN,
  SIZE,
  FONT_TYPE,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import Claim, {
  CLAIM_COLOR,
  CLAIM_SIZE,
} from '@bit/gerenciatd.unifiedcomponents.claim';
import Price, {
  PRICE_COLOR,
  PRICE_DECORATION,
  PRICE_SIZE,
} from '@bit/gerenciatd.unifiedcomponents.price';
import CardRadioButton, { VARIANT } from '../../../CardRadioButton';
import {
  VARIANT as PRODUCT_VARIANT,
  getProductPromotionTextByType,
  TEXT_TYPES_CODES,
} from '../../../ProductItem';
import {
  changeTelcoFormatToFrontFormat,
  changeFrontFormatToCompatibleFormat,
} from '../../../ProductItem/Utils';
import PromotionHired from '../../../ProductItem/PromotionHired';
import { actions as fusionActions } from '../../../../reducers/fusion';
import './ConfiguratorCard.scss';
import { USER_TYPE } from '../../../../constants/constants';

export function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}

export const ConfiguratorCard = ({
  isHired,
  name,
  isdefaultChecked,
  product,
  productHiredUnique,
  handleChangeRadioBtn,
  taggingInfo,
  selectedProduc,
}) => {
  const hiredProduct = productHiredUnique.product.alias;
  const selectedProducnew = selectedProduc;
  const dispatch = useDispatch();

  const { hasClientAlreadyDevice } = useSelector((state) => state.fusion);

  const { data: context } = useSelector((state) => state.context); // context
  const telcoMyHiredProduct = useSelector(
    (state) => state.fusion.myHiredProduct
  );

  let promotionEndDate = null;
  let textoPromo = null;
  let isLastSevenDays = false;
  if (
    context.userType === USER_TYPE.TELCO
    || context.userType === USER_TYPE.GESTOR
  ) {
    const [myHiredProduct] = telcoMyHiredProduct;
    if (myHiredProduct) {
      const { promotions } = myHiredProduct;
      if (promotions && promotions.length > 0) {
        const [promoInfo] = promotions;
        if (promoInfo) {
          const { fechaFin } = promoInfo;
          if (fechaFin) {
            promotionEndDate = changeTelcoFormatToFrontFormat(fechaFin);
            const toDate = new Date(
              changeFrontFormatToCompatibleFormat(promotionEndDate)
            );
            const currentDate = new Date();
            const fromDate = new Date(
              changeFrontFormatToCompatibleFormat(promotionEndDate)
            );

            const dayNumber = currentDate.getDate();
            const startDayNumber = fromDate.getDate();
            if (dayNumber <= 7) {
              const monthNumber = toDate.getMonth();
              fromDate.setMonth(monthNumber - 1);
              const monthDays = daysInMonth(
                monthNumber,
                fromDate.getFullYear()
              );
              fromDate.setDate(monthDays - (7 - startDayNumber));
            } else {
              fromDate.setDate(startDayNumber - 7);
            }

            isLastSevenDays = !!(
              currentDate.getTime() <= toDate.getTime()
              && currentDate.getTime() >= fromDate.getTime()
            );
          }
          if (promoInfo) {
            textoPromo = getProductPromotionTextByType(
              promoInfo,
              TEXT_TYPES_CODES.BRIEF
            );
          }
        }
      }
    }
  }

  const isPromotionHired = isHired
    && promotionEndDate
    && textoPromo
    && isLastSevenDays
    && (context.userType === USER_TYPE.TELCO
      || context.userType === USER_TYPE.GESTOR);

  const isSelectedHiredProduct = isHired;

  const isHiredProduct = product.product.alias === productHiredUnique.product.alias;

  useEffect(() => {
    if (hiredProduct === selectedProducnew) {
      dispatch(fusionActions.setBlockMeIntersa(true));
    } else {
      dispatch(fusionActions.setBlockMeIntersa(false));
    }
  }, [isSelectedHiredProduct]);

  return (
    <CardRadioButton
      variant={isHired ? VARIANT.ORANGE : null}
      isdefaultChecked={isdefaultChecked}
      name={name}
      data={product}
      onChange={handleChangeRadioBtn}
      taggingInfo={taggingInfo}
    >
      {
        <div
          className={`configurator-card__content-wrapper ${isPromotionHired ? '__no-margin' : '__with-margin'
          }`}
        >
          <div className="configurator-card__first-line">
            {isHiredProduct && (
              <Claim
                bgColor={CLAIM_COLOR.GREY_6}
                color={CLAIM_COLOR.WHITE}
                label="CONTRATADO"
                size={CLAIM_SIZE.SMALL}
              />
            )}
            {/* {isSelectedHiredProduct ? (
              <Claim
                bgColor={CLAIM_COLOR.GREY_6}
                color={CLAIM_COLOR.WHITE}
                label="CONTRATADO"
                size={CLAIM_SIZE.SMALL}
              />
            ) : (
              product.recom.promoCode
              && !isPromotionHired && (
                <Claim
                  bgColor={CLAIM_COLOR.PURPLE}
                  color={CLAIM_COLOR.WHITE}
                  label="PROMOCIÓN"
                  size={CLAIM_SIZE.SMALL}
                />
              )
            )} */}
          </div>
          <div className="configurator-card__second-line">
            <div className="configurator-card__second-line__texts">
              <TextInfo
                text={product.product.name}
                kind={KIND_TEXT.PARAGRAPH}
                align={ALIGN.LEFT}
                color={COLOR.BLACK}
                size={SIZE.CAPTION1}
                fontType={FONT_TYPE.REGULAR}
              />
              {product.dataMap.bandaPromo && (
                <TextInfo
                  text={product.dataMap.bandaPromo}
                  kind={KIND_TEXT.PARAGRAPH}
                  align={ALIGN.LEFT}
                  color={COLOR.GREY_5}
                  size={SIZE.CAPTION2}
                  fontType={FONT_TYPE.REGULAR}
                />
              )}
            </div>

            <div className="configurator-card__price-wrapper">
              {product.dataMap.pvpTachado ? (
                <React.Fragment>
                  <Price
                    amount={product.dataMap.pvpTachado}
                    unity={product.dataMap.unidad}
                    color={PRICE_COLOR.GREY_4}
                    decoration={PRICE_DECORATION.LINE_THROUGH}
                    size={PRICE_SIZE.EMP_22}
                  />
                  <Price
                    amount={product.dataMap.pvp}
                    unity={product.dataMap.unidad}
                    color={PRICE_COLOR.EGG}
                    decoration="none"
                    size={PRICE_SIZE.EMP_18}
                  />
                </React.Fragment>
              ) : (
                <Price
                  amount={product.dataMap.pvp}
                  unity={product.dataMap.unidad}
                  color={PRICE_COLOR.EGG}
                  decoration="none"
                  size={PRICE_SIZE.EMP_22}
                />
              )}
            </div>
          </div>
          <div className="configurator-card__promotion-date">
            {isPromotionHired && (
              <PromotionHired
                variant={PRODUCT_VARIANT.HIRED}
                promotionEndDate={promotionEndDate}
                textoPromo={textoPromo}
                isFlyout
              />
            )}
          </div>
        </div>
      }
    </CardRadioButton>
  );
};
